import schema from '@/framework/logic/schema/set-layout-property.schema.json';
import interpolate from '@/framework/logic/shared/interpolate';
import { makeValidated } from '@/framework/logic/shared/utils';

const mapSetLayoutProperty = action => ({
  type: 'LAYOUT_SET',
  payload: {
    value: action.data.value,
    path: action.data.path,
    keep: action.data.keep,
  },
});

const validated = makeValidated(schema);

const setLayoutProperty = (context, event, meta) => {
  return mapSetLayoutProperty(
    validated(interpolate(meta.action, event, context))
  );
};

export default setLayoutProperty;
